/* global __DEBUG__ */
import analytics from '../analytics'
import Swal from '../../../shared/sweetalert'
import { scrollTo } from '../../utils/scroll-helper'

function Form () {
    this.el = null
    this.options = {
        busyClassname: '-busy',
        disableableSelector: 'input, textarea, select, button',
        dummyData: require('./dummy-formdata'),
        errorMessage: 'Sorry, an error occured. Please try again later.',
    }

    if (arguments.length) {
        this.initialize.apply(this, arguments)
    }
}

Form.prototype.initialize = function (element, options) {
    this.el = $(element)
    this.el.on('submit', _.bind(this.onSubmit, this))

    if (typeof options === 'object') {
        let _this = this
        this.options = $.extend({}, _this.options, options)
    }

    if (__DEBUG__) {
        this.prefill()
    }
}

Form.prototype.onSubmit = function (event) {
    event.preventDefault()
    this.send()
}

Form.prototype.disableForm = function () {
    this.el
        .addClass(this.options.busyClassname)
        .find(this.options.disableableSelector)
        .attr('disabled', 'disabled')
}

Form.prototype.enableForm = function () {
    this.el
        .removeClass(this.options.busyClassname)
        .find(this.options.disableableSelector)
        .removeAttr('disabled');
}

Form.prototype.resetForm = function () {
    this.el.find('input, textarea, select')
        .not('.btn')
        .not('[type=checkbox]')
        .not('[type=hidden]')
        .not('[type=radio]')
        .val('');

    this.el.find('[type=checkbox]').removeAttr('checked');
    this.el.trigger('_reset_');
}

Form.prototype.send = function () {
    let data = new FormData(this.el[0])

    this.disableForm()
    this.resetErrors()

    window.axios.post(this.el.attr('action'), data)
        .then(
            response => { this.onMessageSend(response) },
            error => { this.onFailure(error.response) }
        )
        .finally(() => { this.enableForm() })
}

Form.prototype.onMessageSend = function (response) {
    this.resetForm()
    let { data } = response

    analytics.sendEvent(
        'Formulier',
        this.el.attr('action'),
        window.location.pathname
    )

    if (data.redirectUrl) {
        window.location.href = data.redirectUrl
    } else {
        Swal.fire({
            title: data.title,
            text: data.message,
            icon: 'success',
        })
    }
}

Form.prototype.onFailure = function (response) {
    let errorsObject = response.data.errors || {}

    _.each(errorsObject, (err, name) => {
        this.highlightErrorOnField(name, err)
    })

    this.scrollToFirstError()
}

Form.prototype.highlightErrorOnField = function (fieldName) {
    if (-1 < fieldName.indexOf('.')) {
        let parts = fieldName.split('.')
        fieldName = `${parts[0]}[${parts[1]}]`
    }

    let elem = this.el.find('[name="' + fieldName + '"]:visible').first()
    if (elem.length) {
        elem.closest('.form-group').addClass('-has-error')
    }
}

Form.prototype.scrollToFirstError = function () {
    let elem = this.el.find('.-has-error:first')
    if (elem.length) {
        scrollTo(elem.offset().top - 5)
    }
}

Form.prototype.resetErrors = function () {
    let elements = this.el.find('.-has-error')
    if (elements.length) {
        elements.removeClass('-has-error')
    }
}

Form.prototype.prefill = function (data, prop) {
    let values = data || this.options.dummyData

    _.each(values, (value, name) => {
        if (typeof value !== 'string') {
            this.prefill(value, name)
        } else {
            let element = this.el.find('[name="' + (prop ? `${prop}[${name}]` : name) + '"]')
            if (element.val() == '') {
                element.val(value)
            }
        }
    })
}

export default Form;
